import { all, call, put, takeEvery, fork } from 'redux-saga/effects'
import { getImageQualityCheck, getKTPOCR } from '../../request/axios/ocr'
import actions from './actions'

export function * sendKTPOCR () {
  yield takeEvery(actions.SEND_KTP_OCR_REQUEST, function * (data) {
    try {
      const { payload: query = {} } = data

      const res = yield call(getKTPOCR, { query })

      if (
        res?.status === 200 &&
        !(/batas maksimum/i.test(res?.data?.message || '') && /maksimum/i.test(res?.data?.message || ''))
      ) {
        yield put({
          type: actions.SEND_KTP_OCR_SUCCESS,
          payload: res?.data
        })
      } else {
        yield put({
          type: actions.SEND_KTP_OCR_FAILURE,
          payload: res?.data?.message || 'Failed to get OCR result'
        })
      }
    } catch (err) {
      console.error('Saga caught error', err)
      yield put({
        type: actions.SEND_KTP_OCR_FAILURE,
        payload: err?.message || 'Failed to get OCR result'
      })
    }
  })
}

export function * sendImageQualityCheck () {
  yield takeEvery(actions.SEND_IMAGE_QUALITY_CHECK_REQUEST, function * (data) {
    try {
      const { payload: query = {} } = data

      const res = yield call(getImageQualityCheck, { query })

      if (res?.status === 200 && res?.data?.success === true && res?.data?.data !== null) {
        yield put({
          type: actions.SEND_IMAGE_QUALITY_CHECK_SUCCESS,
          payload: res?.data
        })
      } else {
        yield put({
          type: actions.SEND_IMAGE_QUALITY_CHECK_FAILURE,
          payload: res?.data?.message || 'Failed to get OCR result'
        })
      }
    } catch (err) {
      console.error('Saga caught error', err)
      yield put({
        type: actions.SEND_IMAGE_QUALITY_CHECK_FAILURE,
        payload: err || 'Failed to get OCR result'
      })
    }
  })
}

export default function * OCRSaga () {
  yield all([
    fork(sendKTPOCR),
    fork(sendImageQualityCheck)
  ])
}
